// The `expose-loader` doesn't work well with our Webpack DLL set up; therefore
// we're manually exposing jQuery on the `window`.
const $ = require('jquery')

window.jQuery = window.$ = $

module.exports = $
